module.exports = __webpack_public_path__ + "static/media/carbon_play-outline.61319777.svg";